import { render, staticRenderFns } from "./WardMessageList.vue?vue&type=template&id=74ed4ece&"
import script from "./WardMessageList.vue?vue&type=script&lang=js&"
export * from "./WardMessageList.vue?vue&type=script&lang=js&"
import style0 from "./WardMessageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports